<template>
  <div
      :style="{
      gridColumn: `span ${horizontal}`,
      gridRow: `span ${vertical}`
    }"
      class="layout-catalog-category-card"
      @click="locations()"
  >
    <img v-if="image" style="object-fit: cover;" loading="lazy" :data-src="image" alt="locations" class="abs" />
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      default() {
        return ''
      }
    },
    vertical: {
      type: String,
      default() {
        return '1'
      }
    },
    horizontal: {
      type: String,
      default() {
        return '2'
      }
    },
    link: null
  },
  methods: {
    locations(){
      if(this.link){
        location.href=this.link;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-catalog-category-card {
  background: #ccc;
  border-radius: 10px;
  padding: 2em;
  position: relative;
  overflow: hidden;
  z-index: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  transition: 0.3s;
  cursor: pointer;
  &:hover {
    box-shadow: 0px 14px 34px rgba(0, 0, 0, 0.15);
  }
}
img {
  z-index: -1;
  transition: 2s;
  .layout-catalog-category-card:hover & {
    transform: scale(1.2);
  }
}
a {
  background: #fff;
  display: inline-flex;
  padding: 0.7em 1.3em;
  border-radius: 100px;
  margin-top: auto;
  cursor: pointer;
  transition: 0.3s;
  transform: translate3d(0, 6em, 0);
  transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
  .layout-catalog-category-card:hover & {
    transform: translate3d(0, 0, 0);
  }
  &:hover {
    transform: translate3d(0, 0, 0) scale(1.05) !important;
  }
}
@media screen and (max-width: 767px) {
  a {
    transform: translate3d(0, 0, 0);
  }
}
</style>